import cambridgeStandardi from "../../assets/benefits/cambridge-standardi.jpg";
import mentorskiPristup from "../../assets/benefits/mentorski-pristup.jpg";
import triNivoaPodrske from "../../assets/benefits/tri-nivoa-podrske.jpg";
import globalneMogucnosti from "../../assets/benefits/globalne-mogucnosti.jpg";

import num_1 from "../../assets/benefits/new-numbers/1.svg";
import num_2 from "../../assets/benefits/new-numbers/2.svg";
import num_3 from "../../assets/benefits/new-numbers/3.svg";
import num_4 from "../../assets/benefits/new-numbers/4.svg";

const benefitsImages = [
  { img: cambridgeStandardi, num: num_1 },
  { img: mentorskiPristup, num: num_2 },
  { img: triNivoaPodrske, num: num_3 },
  { img: globalneMogucnosti, num: num_4 },
];

export default benefitsImages;
